import { FeedbackForm, SuccessAlert } from '@/components';
import { FEEDBACK } from '@/utils/strings';
import { FC } from 'react';
interface FeedbackFormAlertProps {
  title?: string;
  description?: string;
}
const FeedbackFormAlert: FC<FeedbackFormAlertProps> = ({
  title = FEEDBACK.SECTION_TITLE,
  description = FEEDBACK.SECTION_DESCRIPTION,
}) => {
  return (
    <SuccessAlert
      title={title}
      description={description}
      extraContent={
        <div className="flex w-full pt-3">
          <FeedbackForm />
        </div>
      }
    />
  );
};
export default FeedbackFormAlert;
